import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { catchError, map, Observable, of } from 'rxjs';
import { UserLoginRequestDto, UserLoginResponseDto } from '../../models/auth/auth-dto';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../api/api.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  storageKey = 'user';
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/auth`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService, private readonly router: Router) {}

  login(data: UserLoginRequestDto): Observable<UserLoginResponseDto> {
    return this.http.post<UserLoginResponseDto>(`${this.endpoint}/token`, data);
  }

  logout() {
    this.removeUserData();
    this.router.navigate(['/auth/login']);
  }

  storeUserData(data: UserLoginResponseDto) {
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  removeUserData() {
    localStorage.removeItem(this.storageKey);
  }

  getUserData(): UserLoginResponseDto | null {
    const userData = localStorage.getItem(this.storageKey);
    if (userData) {
      return JSON.parse(userData);
    }
    return null;
  }

  hasPermissions(permissions: string[]): boolean {
    const userData = this.getUserData();
    return userData?.userProfile.permissions.some((permission) => permissions.includes(permission.userFunction.name)) || false;
  }

  validateSession(): Observable<boolean> {
    const userData = this.getUserData();
    if (!userData) {
      return of(false);
    }
    return this.http.get(`${this.endpoint}/verify`).pipe(
      map(() => true),
      catchError((err) => {
        if ([401, 403].includes(err?.status)) {
          return of(false);
        }
        return of(true);
      })
    );
  }
}
